<div class="row m-0 credit-app-body" [ngClass]='{"noshadow": isBuyNow, "h-100": !isBuyNow}'>
  <div class="unlock d-flex align-items-center justify-content-center mx-auto">
    <div class="w-100 text-center">
      <div class="unlock-title p-0 pb-2">Unlock your credit application</div>
      <p class="unlock-msg py-1">
        Last 4 digits of buyer’s Social Security Number
      </p>
      <form [formGroup]="ssnForm">
        <div class="form-group">
            <input formControlName="ssn" [dtTextMask]="{mask: ssnmask, showMask: true}" type="text" class="form-control ssn-input" id="credit-application-ssn"
            [ngClass]="{
              error:
              (ssnForm.get('ssn').touched ||
              ssnForm.get('ssn').dirty) &&
              !ssnForm.get('ssn').valid || (!ssnForm.get('ssn').valid &&
              formSubmitAttempt) ||
              (formSubmitAttempt && !ssnForm.get('ssn').valid)
            }" dtAutoFocus="11"/>
         <div class="invalid-feedback d-block float-left unlock-error">
            <span
              class="form-validator_error"
              *ngIf="
              (ssnForm.get('ssn').touched ||
              ssnForm.get('ssn').dirty) &&
              !ssnForm.get('ssn').valid || (!ssnForm.get('ssn').valid &&
              formSubmitAttempt) ||
              (formSubmitAttempt && !ssnForm.get('ssn').valid) || serverError
            "
              id="credit-application-error"
              >{{errorMessage}}</span
            >
          </div>
        </div>
        <div class="py-4">
          <button
            class="secondary-cta"
            style="width: 265px;"
            id="credit-application-submit-cta"
            (click)="getCreditApp()"
          >
          {{unlockCTA}}
          </button>
        </div>
      </form>
    </div>
  </div>

</div>

<div class="credit-app-cta-section" *ngIf="isBuyNow && inMobile">
  <div class="row m-0 w-100 cta-section">
    <div class="col-12 p-0 d-flex cta-col cta-alignment m-0">
    </div>
  </div>
</div>

